import { get, post } from '@api/request';

export const fetchSearchConfig = async (
  { litigationService },
  authenticationToken,
) => {
  console.log('litigationService', litigationService)
  const url = `${litigationService}/litigation/config/arbitrationsearch`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchSearchResultsConfig = async (
  { litigationService },
  authenticationToken,
) => {
  const url = `${litigationService}/litigation/config/arbitrationsearchresults`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchSearchCodes = async (
  { litigationService },
  authenticationToken,
) => {
  const url = `${litigationService}/litigation/config/arbitrationsearchcodes`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export async function fetchStatusCodes(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/codes?type=Litigation&name=Arbitration Status`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchReasonCodes(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/codes?type=Litigation&name=Arbitration Reasons`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export const search = async (
  { litigationService },
  authenticationToken,
  { pageSize, page, sortField, sortDirection, filterModel, payload },
) => {
  let url = `${litigationService}/litigation/arbitration/search?page=${page}&pageSize=${pageSize}`;

  if (sortField && sortDirection) {
    url += `&sortField=${sortField}&sortDirection=${sortDirection}`;
  }

  if (filterModel && Object.keys(filterModel).length >= 0) {
    Object.keys(filterModel).forEach((filter) => {
      url += `&searchField=${filter}&searchText=${filterModel[filter].value}`;
    });
  }

  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const searchStandalone = async (
  { litigationService },
  authenticationToken,
  { payload },
) => {
  let url = `${litigationService}/litigation/arbitration/search`;

  const { body } = await post(authenticationToken, url, payload);
  return body;
};
